class BESSAppProjectDetailsEditorLocationManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.lookupInProgress = false;
        if (this.editor.projectInputs.streetAddress.input != null) {
            this.editor.projectInputs.streetAddress.input.typeahead({
                minLength: 3,
            }, {
                source: this.onLookupAddress.bind(this),
            }).bind('typeahead:select', this.onSelectGeocodedItem.bind(this));
        }
        this.editor.projectInputs.postcode.addValidator(this.validatePostcode.bind(this));
    }

    onLookupAddress(streetAddress, syncResults, asyncResults) {
        if (streetAddress === undefined) {
            return;
        }

        if (this.lookupInProgress) {
            this.nextLookup = streetAddress;
            return;
        }

        let fullAddress = streetAddress + ' ' +
            this.editor.projectInputs.suburb.getValue() + ' ' +
            this.editor.projectInputs.postcode.getValue();
        let location = this.getLocation();

        this.log("looking up", fullAddress);
        this.log("location", location);
        //this.lookupInProgress = true;

        new google.maps.Geocoder().geocode({
            address: fullAddress,
            componentRestrictions: {
                country: 'AU',
            },
            location: location,
        }, function (results, status) {

            if (status === 'OK') {
                this.results = _.filter(results, (x) => {
                    return _.find(x.address_components, function (a) {
                        return a.types.includes('street_number');
                    }) !== undefined;
                });
                this.log("Geocoded", this.results);

                let names = _.map(this.results, (x) => x.formatted_address);
                asyncResults(names);
            }

            this.lookupInProgress = false;
            if (this.nextLookup !== null) {
                let nextLookup = this.nextLookup;
                this.nextLookup = null;
                this.onLookupAddress(nextLookup, syncResults, asyncResults);
            }

        }.bind(this));
    }

    onSelectGeocodedItem(ev, suggestion) {
        _.each(this.results, function (result) {
            if (result.formatted_address === suggestion) {
                function get_address_component(type) {
                    let component = _.find(result.address_components, function (a) {
                        return a.types.includes(type);
                    });
                    return component === undefined ? null : component;
                }

                let streetNumber = get_address_component('street_number');
                let streetName = get_address_component('route');
                let suburb = get_address_component('locality');
                let council = get_address_component('administrative_area_level_2');
                let state = get_address_component('administrative_area_level_1');
                let postcode = get_address_component('postal_code');

                if (streetName !== null || streetNumber !== null) {
                    let streetAddress =
                        (streetNumber === null ? '' : streetNumber.long_name + ' ') +
                        (streetName === null ? '' : streetName.short_name);
                    this.editor.projectInputs.streetAddress.setValue(streetAddress);
                }
                if (suburb !== null) {
                    this.editor.projectInputs.suburb.setValue(suburb.long_name);
                }
                if (council !== null) {
                    let councilName = this.standardiseMunicipality(council.short_name, 'City Council');
                    if (!this.editor.projectInputs.council.matchValue(councilName)) {
                        let councilName = this.standardiseMunicipality(council.short_name, 'Shire Council');
                    }
                }
                if (state !== null) {
                    //this.editor.projectInputs.state.matchValue(state.short_name);
                }
                if (postcode !== null) {
                    this.editor.projectInputs.postcode.setValue(postcode.short_name);
                }

                let gpsLocation = result.geometry.location;
                let lat = gpsLocation.lat();
                let lng = gpsLocation.lng();

                this.editor.projectInputs.gpsLatitude.setValue(lat);
                this.editor.projectInputs.gpsLongitude.setValue(lng);
                this.editor.projectInputs.map.setValue({'lat': lat, 'lng': lng});
            }
        }.bind(this));
    }

    validatePostcode(input, value) {
        let state = this.editor.projectInputs.state.getValue();
        let stateMinMax = this.editor.projectInputs.state.field.meta.validation[state];
        if (value !== null && value !== '') {
            value = parseInt(value);
            if (value < stateMinMax.min || value > stateMinMax.max) {
                return "Invalid postcode for this state.";
            }
        }
        return null;
    }

    getLocation = function () {
        let latVal = this.editor.projectInputs.gpsLatitude.getValue();
        let lngVal = this.editor.projectInputs.gpsLongitude.getValue();
        let lat = latVal || -37.814107,
            lng = lngVal || 144.963280;

        return {lat: lat, lng: lng};
    }

}